import { createPropTypes } from '@styled-system/prop-types';
import type { ResponsiveValue } from 'styled-system';
import { style } from 'styled-system';

import type { Theme } from '../theme';

type Scale = 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl' | 'xxxl' | 'xs-wordmark';

export type IconSizeProps = {
  size?: ResponsiveValue<Scale, Theme>;
};

const scale: Record<Scale, string> = {
  xxs: '0.625rem',
  xs: '0.75rem',
  s: '0.875rem',
  m: '1rem',
  l: '1.125rem',
  xl: '1.375rem',
  xxl: '1.75rem',
  xxxl: '3rem',
  'xs-wordmark': '1.4rem',
};

const sizeStyle: any = style({
  // React prop name
  prop: 'size',
  // The corresponding CSS property (defaults to prop argument)
  cssProperty: 'font-size',
  // key for theme values
  key: 'iconSizes',
  // accessor function for transforming the value
  // eslint-disable-next-line security/detect-object-injection
  transformValue: (n: Scale) => scale[n],
  // add a fallback scale object or array, if theme is not present
  scale,
});
sizeStyle.propTypes = createPropTypes(['size']);

// eslint-disable-next-line import/no-default-export
export default sizeStyle;
